export default {
    organizationFederationShow: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/organizations/:organizationId/federation',
    },
    organizationFederationGenerateUrls: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/organizations/:organizationId/federation/generate-urls',
    },
    organizationFederationUpdate: {
        method: 'PUT',
        url: process.env.VUE_APP_API_URL + '/organizations/:organizationId/federation',
    },
    organizationFederationPatch: {
        method: 'PATCH',
        url: process.env.VUE_APP_API_URL + '/organizations/:organizationId/federation',
    },
    organizationFederationAddUser: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/organizations/:organizationId/federation/users',
    },
    organizationFederationRemoveUser: {
        method: 'DELETE',
        url: process.env.VUE_APP_API_URL + '/organizations/:organizationId/federation/users/:userId',
    },
};
